import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';
import classNames from 'classnames';

import L from 'leaflet';

import './map-search.less';
import SearchField from "components/ui/search-field";
import {connect} from "react-redux";
import TextField from "components/ui/text-field";
import 'leaflet.pm';
import 'leaflet.pm/dist/leaflet.pm.css';
import _ from 'lodash';
import {searchAddress} from "store/reducers/geo/geocoding";
import debounce from 'throttle-debounce/debounce';
import * as alerts from "helpers/alerts";
import MapZoomButton from "components/ui/map-zoom-button";
import {getStopPointsWithBounds} from "store/reducers/routes/routes";

@propTypes({
    onClick: PropTypes.func.isRequired,
    map: PropTypes.object.isRequired,
})

@defaultProps({})

@connect(state => ({}), {searchAddress, getStopPointsWithBounds})

export default class MapSearch extends Component {

    suggestAddressDebounce = debounce(500, ::this.suggestAddress);

    state = {
        collapsed: false,
        hasResult: false,
        suggests: [],
        activeSuggest: null,
    };

    render() {
        const toggleBtnText = this.state.collapsed ? <span>&darr; Показать</span> : <span>&uarr; Скрыть</span>;

        let results = null;
        if (this.state.suggests.length > 0) {
            results = (
                <div className="results">
                    <div className="toggle-btn" onClick={::this.toggleClick}>
                        {toggleBtnText}
                    </div>
                    <div className="list">
                        {this.state.collapsed ? null : this.state.suggests.map(::this.renderItem)}
                    </div>
                </div>
            );
        } else if (this.state.hasResult) {
            results = (
                <div className="results">
                    <div className="list">
                        <div className="list-item inactive">
                            Поиск не дал результатов
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div>
                <div className="MapSearch">
                    <div className="f-search f-search-posit visible">
                        <form action="#">
                            <TextField placeholder="Поиск" withoutWrapper={true} className="f-search__pole" ref="input"
                                       onChange={::this.suggestAddressDebounce}
                                       onEnter={::this.onClick}/>
                            <input className="f-search__button" type="button" onClick={::this.onClick}/>
                            {this.state.activeSuggest ? (
                                <MapZoomButton type="closest" tooltip="Ближайшие остановки"
                                               onClick={::this.loadClosest}/>
                            ) : null}
                        </form>
                    </div>
                    {results}
                </div>
            </div>
        );
    }

    async loadClosest() {
        const point = new L.latLng(this.state.activeSuggest.latitude, this.state.activeSuggest.longitude);
        const bounds = point.toBounds(2000);
        const boundingBox = {
            left_top: {
                latitude: bounds.getNorth(),
                longitude: bounds.getEast(),
            },
            right_bottom: {
                latitude: bounds.getSouth(),
                longitude: bounds.getWest(),
            },
        };
        const response = await this.props.getStopPointsWithBounds(boundingBox, this.props.zoom);

        if (response.isOk) {
            const stopPointTitles = _.map(_.slice(_.uniqBy(_.sortBy(response.payload.items, (item) => {
                const itemPoint = new L.latLng(item.latitude, item.longitude);

                return itemPoint.distanceTo(point);
            }), 'title'), 0, 5), 'title');
            const filtered = _.filter(response.payload.items, (item) => {
                return _.indexOf(stopPointTitles, item.title) !== -1;
            });
            const stopPoints = _.map(_.slice(_.uniqBy(_.sortBy(filtered, (item) => {
                const itemPoint = new L.latLng(item.latitude, item.longitude);

                return itemPoint.distanceTo(point);
            }), 'title'), 0, 5), 'uuid');

            this.props.setSearchStopPoints(_.map(filtered, (item) => {
                item.permanent = _.indexOf(stopPoints, item.uuid) !== -1;

                return item;
            }));
        } else {
            response.showErrors();
        }
    }

    onClick() {
        const first = _.first(this.state.suggests);
        if (!first) {
            return;
        }

        this.setState({
            activeSuggest: first,
        });
        this.props.onClick(first);
    }

    async suggestAddress() {
        const input = this.refs.input.getValue();
        if (!input) {
            this.setState({
                collapsed: false,
                hasResult: false,
                suggests: [],
                activeSuggest: null,
            });
            this.props.setSearchStopPoints([]);
            return;
        }

        const bounds = this.props.map.getBounds();
        const boundingBox = {
            left: bounds.getNorth(),
            top: bounds.getEast(),
            right: bounds.getSouth(),
            bottom: bounds.getWest(),
        };

        const response = await this.props.searchAddress(input, boundingBox, this.props.zoom);

        if (response.isOk) {
            this.setState({
                suggests: _.sortBy(_.map(response.payload.items, (item) => ({
                    value: item.name,
                    label: item.name,
                    latitude: item.coordinates.latitude,
                    longitude: item.coordinates.longitude,
                })), 'label'),
                hasResult: true,
            });
        } else {
            response.showErrors();
        }
    }

    renderItem(item, index) {
        return (
            <div className="list-item" key={index} onClick={this.onItemClick.bind(this, item)}>
                {item.label}
            </div>
        );
    }

    onItemClick(object) {
        this.setState({
            activeSuggest: object,
        });
        this.props.onClick(object);
    }

    expand() {
        this.setState({collapsed: false});
    }

    collapse() {
        this.setState({collapsed: true});
    }

    toggleClick() {
        this.state.collapsed ? this.expand() : this.collapse();
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/map-search.js